/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * BehaviourTrendsCard
 *
 * @file  BehaviourTrendsCard.jsx
 * @since 1.0.0
 */

import React from 'react';
import { Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import CustomCircularProgress from '../common/CustomCircularProgress ';
import useBehaviorTrendsStyles from './styles/BehaviourTrendsStyle';
import mixins from '../../assets/styles/mixins.scss';

const BehaviorTrendsCard = (props) => {
  const { behaviorTrends = [], ...otherProps } = props;
  const classes = useBehaviorTrendsStyles(props);

  return (
    <Box className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        {otherProps.textInfo.behaviourTrendsLabel}
      </Typography>

      <Box className={classes.trendsContainer}>
        {behaviorTrends.map((trend) => (
          <Box key={trend.id} className={classes.trendItem}>
            <CustomCircularProgress
              radius={46}
              value={trend.percentage}
              color={mixins.amethyst}
              incompleteColor={mixins.incompleteProgressColor}
              borderWidth={4}
            >
              <Typography className={classes.percentText}>
                {trend.percentage}%
              </Typography>
            </CustomCircularProgress>

            <Box className={classes.trendText}>
              <Typography className={classes.valueText}>
                {trend.valueText}
              </Typography>
              <Typography className={classes.descriptionText}>
                {trend.description}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default BehaviorTrendsCard;

BehaviorTrendsCard.propTypes = {
  behaviorTrends: PropTypes.array.isRequired
};
